// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__26000","messages":"style_messages__3AAPP","sentinel":"style_sentinel__3JWQ0"};